module.exports = __webpack_public_path__ + "img/followDoc_c.96e54ba6.png";